import { useState, useEffect } from "react";
import DashboardLayout from "../../components/Layout/DashboardLayout";
import Breadcrumbs from "../../components/Layout/Breadcrumbs";
import { Card, Button, Form, Spinner } from "react-bootstrap";
import api from "../../services/api";
import MiniFooter from "../../components/Layout/miniFooter";

export default function UrlExpirySettings() {
  const breadcrumbItems = [
    { name: "Dashboard", path: "/user-dashboard" },
    { name: "URL Expiry Settings" },
  ];

  const [expiryEnabled, setExpiryEnabled] = useState(null); // true / false
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState("");

  // Fetch current global expiry setting
  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await api.get("/settings/url-expiry");
        setExpiryEnabled(res.data.expiryEnabled); // assume API returns { expiryEnabled: true/false }
      } catch (err) {
        console.error(err);
        setMessage("Failed to load settings.");
      } finally {
        setLoading(false);
      }
    };

    fetchSettings();
  }, []);

  const handleSave = async () => {
    setSaving(true);
    setMessage("");
    try {
      await api.post("/settings/url-expiry", { expiryEnabled });
      setMessage("Settings saved successfully.");
    } catch (err) {
      console.error(err);
      setMessage("Failed to save settings.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <DashboardLayout>
      <div className="container mt-4">
        {/* Breadcrumb */}
        <Breadcrumbs items={breadcrumbItems} />

        {/* Page Header */}
        <div className="mb-4">
          <h3 className="mb-1">URL Expiry Settings</h3>
          <p className="text-muted mb-0">
            Keep your account clean and healthy by deleting old expired data. 
            These settings will be applied globally to all your short URLs and stats/analytics.
          </p>
        </div>

        {/* Settings Card */}
        <Card className="shadow-sm rounded-3 p-4 mb-4">
          {loading ? (
            <div className="text-center py-5">
              <Spinner animation="border" />
            </div>
          ) : (
            <>
              {message && (
                <div
                  className={`alert ${
                    message.includes("failed") ? "alert-danger" : "alert-success"
                  }`}
                >
                  {message}
                </div>
              )}

              <Form>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Do you want to set an expiry date on short URLs?
                  </Form.Label>
                  <div className="d-flex flex-column mt-2 gap-2">
                    <Form.Check
                      type="radio"
                      label="Yes, I want to set an expiry date on my short URLs data"
                      name="expiry"
                      checked={expiryEnabled === true}
                      onChange={() => setExpiryEnabled(true)}
                    />
                    <Form.Check
                      type="radio"
                      label="No, my short URLs data never expire"
                      name="expiry"
                      checked={expiryEnabled === false}
                      onChange={() => setExpiryEnabled(false)}
                    />
                  </div>
                </Form.Group>

                <Button
                  variant="primary"
                  onClick={handleSave}
                  disabled={saving || expiryEnabled === null}
                >
                  {saving ? "Saving..." : "Save Settings"}
                </Button>
              </Form>
            </>
          )}
        </Card>
      </div>
      <MiniFooter />
    </DashboardLayout>
  );
}